import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  CircularProgress,
  Divider,
} from '@mui/material';
import { useAppSelector } from '../../store/hooks';

interface ViewTableModalProps {
  open: boolean;
  onClose: () => void;
}

const ViewTableModal: React.FC<ViewTableModalProps> = ({ open, onClose }) => {
  const { selectedTable, loading } = useAppSelector((state) => state.tables);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Detalle de la Tabla</DialogTitle>
      <DialogContent>
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
            <CircularProgress />
          </Box>
        ) : selectedTable ? (
          <Box sx={{ mt: 2 }}>
            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Esquema
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedTable.schemaName}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Nombre de la Tabla
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedTable.tableName}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Descripción
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedTable.description}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Propósito
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedTable.purpose}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Columnas de Llave Primaria
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedTable.primaryKeyColumns.join(', ')}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Palabras Clave
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedTable.keywords.join(', ')}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Contexto de Negocio
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedTable.businessContext}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Fecha de Creación
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedTable.createdAt}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Fecha de Actualización
              </Typography>
              <Typography variant="body1">
                {selectedTable.updatedAt}
              </Typography>
            </Box>
          </Box>
        ) : (
          <Typography>No hay tabla seleccionada</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewTableModal;
